module.exports = __webpack_public_path__ + "static/img/appstore_dark.bbd1ab11.png";